/*
 *  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
 *  ~ No part of this publication may be reproduced, distributed,
 *  ~ or transmitted in any form or by any means, including photocopying, recording,
 *  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
 *  ~ except in the case of brief quotations embodied in critical
 *  ~ reviews and certain other noncommercial uses permitted by copyright law.
 *  ~ Author : BS
 *  ~ Date : 3/9/23, 4:56 PM
 */

import MapTypeStyle = google.maps.MapTypeStyle;
import { CommonUtils } from '@infodata-group/inf-commons';
import { SerializedGmapsThemeInterface } from '../interface/serialized/serialized-gmaps-theme.interface';

export class GmapsTheme {
  public id: string;
  public label: string;
  public img: string;
  public mapTypeStyle: MapTypeStyle[];
  public tags: string[];

  constructor(
    id: string,
    label: string,
    img: string,
    mapTypeStyle: MapTypeStyle[]
  ) {
    this.id = id;
    this.label = label;
    this.img = img;
    this.mapTypeStyle = mapTypeStyle;
  }

  public serialize(): SerializedGmapsThemeInterface {
    return {
      id: this.id,
      label: this.label,
      img: this.img,
      mapTypeStyle: this.mapTypeStyle,
    };
  }

  public match(value: string): boolean {
    const normalizedValue = CommonUtils.normalize(value, true);
    return (
      CommonUtils.normalize(this.label, true).includes(normalizedValue) ||
      CommonUtils.normalize(this.tags.join(' '), true).includes(normalizedValue)
    );
  }
}
